import axios, { AxiosResponse, HttpStatusCode } from "axios";
import {
  TWILIO_ACCOUNT_SID,
  TWILIO_AUTH_TOKEN,
  TWILIO_BASE_URL,
  TWILIO_SERVICE_SID,
} from "../../constants/twilio";
import { appActions } from "../../ducks/app";
import { Configuration } from "../api/configuration";
import { TwilioCheckAPI, TwilioSendAPI } from "../api/requests";
import { APIError } from "../types";
import { ErrorMessageManager } from "./ErrorMessageManager";

const API_BASE_URL = TWILIO_BASE_URL + TWILIO_SERVICE_SID;

const configuration = new Configuration({
  basePath: API_BASE_URL,
});

export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  auth: {
    username: TWILIO_ACCOUNT_SID,
    password: TWILIO_AUTH_TOKEN,
  },
});

// リクエスト前の処理
axiosInstance.interceptors.request.use((config) => {
  config.headers["Content-Type"] = "application/x-www-form-urlencoded";
  return config;
});

export const requestSuccess = (config: AxiosResponse<any, any>) => {
  return { ...config, response: { data: config.data } };
};

export const requestFailure = (error: APIError, store: any) => {
  const showErrorAlert = (errorCode: string) => {
    const errorMessage: string =
      ErrorMessageManager.Instance.getErrorMessage(errorCode);
    store.dispatch(
      appActions.showModal.started({
        title: errorMessage,
        nextButtonLabel: "閉じる",
        handleNext: () => store.dispatch(appActions.closeModal()),
      }),
    );
  };

  // TODO: Update error handling
  if (!error) {
  } else if (error && error.code === "ERR_NETWORK") {
    showErrorAlert("0000-0000");
  } else if (
    error &&
    error.response?.status === HttpStatusCode.ServiceUnavailable
  ) {
    showErrorAlert("9900-9999");
  } else if (
    error &&
    error.response?.status === HttpStatusCode.TooManyRequests
  ) {
    showErrorAlert("9900-9999");
  } else {
    showErrorAlert("AUTH-9001");
  }
  return Promise.reject({
    ...error,
    status: error.response?.status ?? HttpStatusCode.InternalServerError,
  });
};

const twilioCheckApi = new TwilioCheckAPI(configuration, axiosInstance);
const twilioSendApi = new TwilioSendAPI(configuration, axiosInstance);

export { twilioCheckApi, twilioSendApi };
